export default __webpack_public_path__ + "static/removingPants-d5c7394f6e8b46d524ee7e5ed959078b.svg";